<div class="g-layout__container">
  <div class="mb-5">
    <div class=" flex justify-content-between align-items-center">
      <div class="flex align-items-center" (click)="goBack()">
        <div class="flex cursor-pointer align-items-center ml-2">
          @if(dir=='rtl'){

          <i class="pi pi-angle-right g-c-primaryDarkerColor text-xl"></i>
          }@else {

          <i class="pi pi-angle-left g-c-primaryDarkerColor text-xl"></i>
          }
        </div>

        <p class="font-bold  g-c-primaryDarkerColor">
          {{projectId>0?'تعديل المبادرة':'إضافة المبادرة'}} :<span class="mx-2">
            {{project.name}}
          </span>
        </p>
      </div>
    </div>
    <div class="br"></div>
  </div>

  <!-- {{canSeeStrategyReviewTabs && project.assessment_status == "approved"|json}} -->


  @if(canSeeStrategyReviewTabs){
  <div class="project-stepper-shell">
    <p-stepper [dir]="dir" [linear]="projectId==0?true:false" [(activeStep)]="active">
      <p-stepperPanel header="{{'initiative_basic_data' | translate}}">
        <ng-template pTemplate="content" let-nextCallback="nextCallback" let-index="index">
          <div>
            <app-project [user]="user" [project]="project" [strategicRelations]="strategicRelations"
              [strategy]="strategy" (submitSuccess)="ProjectSubmitSuccess($event)"></app-project>
            <button pButton class="mt-4" (click)="submitProjectForm()">{{'next' | translate }}</button>
          </div>
        </ng-template>
      </p-stepperPanel>
      <p-stepperPanel header="{{'stakeholders' | translate}}">
        <ng-template pTemplate="content" let-prevCallback="prevCallback" let-nextCallback="nextCallback"
          let-index="index">
          <app-stakeholders (submitStackholderSuccess)="StakeholderSuccess($event)"
            [ProjectsRelations]="ProjectsRelations" [strategyId]="strategyId" [employees]="ProjectsRelations.employees"
            [stakeholder]="project.stakeholder"></app-stakeholders>
          <div class="flex pt-4 justify-content-between">
            <p-button label="{{'back' | translate }}" (onClick)="prevCallback.emit()" />
            <p-button label="{{'next' | translate }}" (onClick)="submitStakeholdersForm()" />
          </div>
        </ng-template>
      </p-stepperPanel>
      <p-stepperPanel header="{{'work_team' | translate}}">
        <ng-template pTemplate="content" let-prevCallback="prevCallback" let-index="index"
          let-nextCallback="nextCallback">
          <app-team-member [teamMembers]="team_members" [ProjectsRelations]="ProjectsRelations" [project]="project"
            [projectId]="projectId" [strategyId]="strategyId"
            (teamMembersChanged)="onTeamMembersChanged($event)"
            (teamLeaderChanged)="onTeamLeaderChanged($event)"></app-team-member>
          <div class="flex pt-4 justify-content-between">
            <p-button label="{{'back' | translate }}" (onClick)="prevCallback.emit()" />
            <p-button label="{{'next' | translate }}" (onClick)="nextCallback.emit()" />
          </div>
        </ng-template>
      </p-stepperPanel>
      <p-stepperPanel header="{{'resources' | translate}}">
        <ng-template pTemplate="content" let-prevCallback="prevCallback" let-index="index"
          let-nextCallback="nextCallback">
          <div>
            <app-resource (submitResourceSuccess)="submitResourceSuccess()" [projectId]="projectId"
              [strategyId]="strategyId" [Resource]="resource"></app-resource>
          </div>
          <div class="flex pt-4 justify-content-between">
            <p-button label="{{'back' | translate }}" (onClick)="prevCallback.emit()" />
            <p-button label="{{'next' | translate }}" (onClick)="submitResourceForm()" />
          </div>
        </ng-template>
      </p-stepperPanel>
      <p-stepperPanel header="{{'risks' | translate}}">
        <ng-template pTemplate="content" let-prevCallback="prevCallback" let-index="index"
          let-nextCallback="nextCallback">

          <div>
            <app-risks [strategyId]="strategyId" [project]="project" [projectId]="projectId"
              [ProjectsRelations]="ProjectsRelations" [risks]="risks"></app-risks>
          </div>

          <div class="flex pt-4 justify-content-between">
            <p-button label="{{'back' | translate }}" (onClick)="prevCallback.emit()" />
            <p-button label="{{'next' | translate }}" (onClick)="nextCallback.emit()" />
          </div>
        </ng-template>
      </p-stepperPanel>
      <p-stepperPanel header="{{'implementation' | translate}}">
        <ng-template pTemplate="content" let-prevCallback="prevCallback" let-index="index"
          let-nextCallback="nextCallback">
          <app-milestone [assessment_status]="project.assessment_status" [milestones]="milestones"
            [strategyId]="strategyId" [project]="project" [projectId]="projectId"
            [employees]="ProjectsRelations?.employees"></app-milestone>
          <div class="flex pt-4 justify-content-between">
            <p-button label="{{'back' | translate }}" (onClick)="prevCallback.emit()" />
            <p-button label="{{'next' | translate }}" (onClick)="nextCallback.emit()" />
          </div>
        </ng-template>
      </p-stepperPanel>
      <p-stepperPanel header="{{'submission_request' | translate}}">
        <ng-template pTemplate="content" let-prevCallback="prevCallback" let-index="index"
          let-nextCallback="nextCallback">
          <div>
            <!-- [completionStatus]="completionStatus" -->
            <app-project-submission #projectSubmission (isSubmissionCreated)="changeIsSubmitted($event)" [is_submitted]="is_submitted"
              [strategyId]="strategyId" [projectId]="projectId" [projectName]="project.name"></app-project-submission>
          </div>
          <div class="flex pt-4 justify-content-between">
            <p-button label="{{'back' | translate }}" (onClick)="prevCallback.emit()" />
            <p-button label="{{'submit_initiative' | translate}}" (onClick)="projectSubmission.submit()" />
          </div>
        </ng-template>
      </p-stepperPanel>
      <p-stepperPanel header="{{'submission_review' | translate}}">
        <ng-template let-nextCallback="nextCallback" pTemplate="content" let-prevCallback="prevCallback"
          let-index="index">
          <div>

            <app-project-review #projectReview [project]="project" [submissionId]="submissionId" [strategyId]="strategyId"
              [projectId]="projectId"></app-project-review>
          </div>
          <div class="flex pt-4 justify-content-between">
            <p-button label="{{'back' | translate }}" (onClick)="prevCallback.emit()" />
            @if(projectReview.canSubmitReview){
            <p-button icon="pi pi-send" label="{{'send_review_result'|translate}}" (onClick)="projectReview.updateSubmission()" />
            }@else{
            <p-button label="{{'next' | translate }}" (onClick)="nextCallback.emit()" />
            }
          </div>
        </ng-template>
      </p-stepperPanel>
      <p-stepperPanel header="{{'submission_results' | translate}}">
        <ng-template pTemplate="content" let-nextCallback="nextCallback" let-prevCallback="prevCallback"
          let-index="index">
          <div>
            <app-project-submission-result [strategyId]="strategyId"
              [projectId]="projectId"></app-project-submission-result>
          </div>
          <div class="flex pt-4 justify-content-between">
            <p-button label="{{'back' | translate }}" (onClick)="prevCallback.emit()" />
            <p-button label="{{'next' | translate }}" (onClick)="nextCallback.emit()" />
          </div>
        </ng-template>
      </p-stepperPanel>

      <p-stepperPanel header="{{'initiative_management' | translate}}">
        <ng-template let-nextCallback="nextCallback" pTemplate="content" let-prevCallback="prevCallback"
          let-index="index">

          <div>
            <app-plan [strategyId]="strategyId" [project]="project" [projectId]="projectId"></app-plan>
          </div>
          <div class="flex pt-4 justify-content-between">
            <p-button label="{{'back' | translate }}" (onClick)="prevCallback.emit()" />
            <p-button label="{{'next' | translate }}" (onClick)="nextCallback.emit()" />
          </div>
        </ng-template>
      </p-stepperPanel>
      <p-stepperPanel header="{{'chat' | translate}}">
        <ng-template let-nextCallback="nextCallback" pTemplate="content" let-prevCallback="prevCallback"
          let-index="index">

          <div>
            <app-chat [strategyId]="strategyId" [projectId]="projectId"></app-chat>
          </div>
          <div class="flex pt-4 justify-content-between">
            <p-button label="{{'back' | translate }}" (onClick)="prevCallback.emit()" />
            <p-button label="{{'next' | translate }}" (onClick)="nextCallback.emit()" />
          </div>
        </ng-template>
      </p-stepperPanel>
    </p-stepper>
  </div>
  }@else{
  <div class="project-stepper-shell">
    <p-stepper [linear]="projectId==0?true:false" [(activeStep)]="active">
      <p-stepperPanel header="{{'initiative_basic_data' | translate}}">
        <ng-template pTemplate="content" let-nextCallback="nextCallback" let-index="index">
          <div>
            <app-project [user]="user" [project]="project" [strategicRelations]="strategicRelations"
              [strategy]="strategy" (submitSuccess)="ProjectSubmitSuccess($event)"></app-project>
            <button pButton class="mt-4" (click)="submitProjectForm()">{{'next' | translate }}</button>
          </div>
        </ng-template>
      </p-stepperPanel>
      <p-stepperPanel header="{{'stakeholders' | translate}}">
        <ng-template pTemplate="content" let-prevCallback="prevCallback" let-nextCallback="nextCallback"
          let-index="index">
          <app-stakeholders (submitStackholderSuccess)="StakeholderSuccess($event)"
            [ProjectsRelations]="ProjectsRelations" [strategyId]="strategyId" [employees]="ProjectsRelations.employees"
            [stakeholder]="project.stakeholder"></app-stakeholders>
          <div class="flex pt-4 justify-content-between">
            <p-button label="{{'next' | translate }}" (onClick)="submitStakeholdersForm()" />
            <p-button label="{{'back' | translate }}" (onClick)="prevCallback.emit()" />
          </div>
        </ng-template>
      </p-stepperPanel>
      <p-stepperPanel header="{{'work_team' | translate}}">
        <ng-template pTemplate="content" let-prevCallback="prevCallback" let-index="index"
          let-nextCallback="nextCallback">
          <app-team-member [teamMembers]="team_members" [ProjectsRelations]="ProjectsRelations" [project]="project"
            [projectId]="projectId" [strategyId]="strategyId"
            (teamMembersChanged)="onTeamMembersChanged($event)"
            (teamLeaderChanged)="onTeamLeaderChanged($event)"></app-team-member>
          <div class="flex pt-4 justify-content-between">
            <p-button label="{{'next' | translate }}" (onClick)="nextCallback.emit()" />
            <p-button label="{{'back' | translate }}" (onClick)="prevCallback.emit()" />
          </div>
        </ng-template>
      </p-stepperPanel>
      <p-stepperPanel header="{{'resources' | translate}}">
        <ng-template pTemplate="content" let-prevCallback="prevCallback" let-index="index"
          let-nextCallback="nextCallback">
          <div>
            <app-resource (submitResourceSuccess)="submitResourceSuccess()" [projectId]="projectId"
              [strategyId]="strategyId" [Resource]="resource"></app-resource>
          </div>
          <div class="flex pt-4 justify-content-between">
            <p-button label="{{'next' | translate }}" (onClick)="submitResourceForm()" />
            <p-button label="{{'back' | translate }}" (onClick)="prevCallback.emit()" />
          </div>
        </ng-template>
      </p-stepperPanel>
      <p-stepperPanel header="{{'risks' | translate}}">
        <ng-template pTemplate="content" let-prevCallback="prevCallback" let-index="index"
          let-nextCallback="nextCallback">

          <div>
            <app-risks [strategyId]="strategyId" [project]="project" [projectId]="projectId"
              [ProjectsRelations]="ProjectsRelations" [risks]="risks"></app-risks>
          </div>

          <div class="flex pt-4 justify-content-between">
            <p-button label="{{'next' | translate }}" (onClick)="nextCallback.emit()" />
            <p-button label="{{'back' | translate }}" (onClick)="prevCallback.emit()" />
          </div>
        </ng-template>
      </p-stepperPanel>
      <p-stepperPanel header="{{'implementation' | translate}}">
        <ng-template pTemplate="content" let-prevCallback="prevCallback" let-index="index"
          let-nextCallback="nextCallback">
          <app-milestone [assessment_status]="project.assessment_status" [milestones]="milestones"
            [strategyId]="strategyId" [project]="project" [projectId]="projectId"
            [employees]="ProjectsRelations?.employees"></app-milestone>
          <div class="flex pt-4 justify-content-between">
            <p-button label="{{'next' | translate }}" (onClick)="nextCallback.emit()" />
            <p-button label="{{'back' | translate }}" (onClick)="prevCallback.emit()" />
          </div>
        </ng-template>
      </p-stepperPanel>
      <p-stepperPanel header="{{'submission_request' | translate}}">
        <ng-template pTemplate="content" let-prevCallback="prevCallback" let-index="index"
          let-nextCallback="nextCallback">
          <div>
            <!-- [completionStatus]="completionStatus" -->
            <app-project-submission #projectSubmission2 (isSubmissionCreated)="changeIsSubmitted($event)" [is_submitted]="is_submitted"
              [strategyId]="strategyId" [projectId]="projectId" [projectName]="project.name"></app-project-submission>
          </div>
          <div class="flex pt-4 justify-content-between">
            <p-button label="{{'submit_initiative' | translate }}" (onClick)="projectSubmission2.submit()" />
            <p-button label="{{'back' | translate }}" (onClick)="prevCallback.emit()" />
          </div>
        </ng-template>
      </p-stepperPanel>
      <p-stepperPanel header="{{'submission_results' | translate}}">


        <ng-template pTemplate="content" let-nextCallback="nextCallback" let-prevCallback="prevCallback"
          let-index="index">
          <div>
            <app-project-submission-result [strategyId]="strategyId"
              [projectId]="projectId"></app-project-submission-result>
          </div>
          <div class="flex pt-4 justify-content-between">
            <p-button label="{{'back' | translate }}" (onClick)="prevCallback.emit()" />
          </div>
        </ng-template>
      </p-stepperPanel>
      <p-stepperPanel header="{{'chat' | translate}}">
        <ng-template let-nextCallback="nextCallback" pTemplate="content" let-prevCallback="prevCallback"
          let-index="index">

          <div>
            <app-chat [strategyId]="strategyId" [projectId]="projectId"></app-chat>
          </div>
          <div class="flex pt-4 justify-content-between">
            <p-button label="{{'back' | translate }}" (onClick)="prevCallback.emit()" />
            <p-button label="{{'next' | translate }}" (onClick)="nextCallback.emit()" />
          </div>
        </ng-template>
      </p-stepperPanel>
    </p-stepper>

  </div>
  }



</div>